import { Link } from "react-router-dom";

const CompanySettings = () => {
  const menuList = [
    {
      name: "Leave structure",
      description: "Manage leave structure: add, edit and delete leave types",
      to: "/company-settings/leave-structure",
    },
    {
      name: "Salary structure",
      description: "Manage salary structure",
      to: "/company-settings/salary-structure",
    },
    // {
    //   name: "Salary structure",
    //   description: "Manage salary structure: add, edit and delete salary types",
    //   to: "/company-settings/salary-structure",
    // },
  ];

  return (
    <div className="px-5 pt-10">
      <h1 className=" text-xl font-bold mb-6">Company Settings</h1>

      {menuList.map((menu, index) => {
        const { name, description, to } = menu;
        return (
          <>
            <Link key={index} to={to} className="w-full ">
              <p className="text-gray-700 font-medium text-lg">{name}</p>
              <p className="text-gray-400">{description}</p>
            </Link>
            <hr className="my-4 border-top border-gray-300" />
          </>
        );
      })}
    </div>
  );
};

export default CompanySettings;
